<script>
  import { useNavigate, Route } from "svelte-navigator";
  import { useUrlParams } from "@stores/urlStore.js";
  import { PREPROCESSING_SUBROUTES, ROUTES } from "@utils/routes.js";
  import AppPreprocessing from "./preprocessing/AppPreprocessing.svelte";
  import UiNamePreprocessing from "./preprocessing/UINamePreprocessing.svelte";
  import PreprocessingSummary from "./preprocessing/PreprocessingSummary.svelte";
  import CaseIdPreprocessing from "./preprocessing/CaseIdPreprocessing.svelte";
  import PreprocessingScreens from "./preprocessing/PreprocessingScreens.svelte";
  import { SectionWrapper } from "paxray-components-svelte";
  import OverviewPreprocessing from "./preprocessing/OverviewPreprocessing.svelte";

  const urlParams = useUrlParams();
  const navigate = useNavigate();
  let redirected = false;

  $: ({ analysisid, idproject } = $urlParams);
  $: hasRequiredParams = Boolean($urlParams.idproject && $urlParams.analysisid);
  $: if (!hasRequiredParams && !redirected) {
    redirected = true;
    Promise.resolve(navigate(ROUTES.dam.root, { replace: true })).catch(() => {
      window.location.replace(ROUTES.dam.root);
    });
  }
  $$restProps;
</script>

<SectionWrapper fullscreen={true}>
  <div class="main" slot="main">
    <Route path={PREPROCESSING_SUBROUTES.appPreprocessing}
      ><AppPreprocessing {idproject} /></Route
    >
    <Route path={PREPROCESSING_SUBROUTES.uiPreprocessingText}
      ><UiNamePreprocessing {idproject} /></Route
    >
    <Route path={PREPROCESSING_SUBROUTES.uiPreprocessingScreen}
      ><PreprocessingScreens {analysisid} /></Route
    >
    <Route path={PREPROCESSING_SUBROUTES.caseIdPreprocessing}
      ><CaseIdPreprocessing {analysisid} {idproject} /></Route
    >
    <Route path={PREPROCESSING_SUBROUTES.preprocessingSummary}
      ><PreprocessingSummary {analysisid} /></Route
    >
    <Route path={PREPROCESSING_SUBROUTES.overviewPreprocessing}
      ><OverviewPreprocessing {analysisid} /></Route
    >
  </div>
</SectionWrapper>

<style>
  .main {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
</style>
